import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Home from './Pages/Home'
import Account from './Pages/Account'
import ProductDetail from './Pages/ProductDetail'
import Login from './Pages/Login'
import Register from './Pages/Register'
import Categories from './Pages/Categories'
import TopChart from './Pages/TopChart'
import ForgotPassword from './Pages/ForgotPassword'
import CategoryDetail from './Pages/CategoryDetail'
import ChangePassword from './Pages/ChangePassword'
import EditProfile from './Pages/EditProfile'
import ProductSearch from './Pages/ProductSearch'

export default function Routes() {
  return (
    <Router>
      <Switch>
        <Route exact path='/' component={Home} />
        <Route path='/account' component={Account} />
        <Route path='/detail/:id' component={ProductDetail} />
        <Route path='/login' component={Login} />
        <Route path='/register' component={Register} />
        <Route path={'/detail'} component={ProductDetail} />
        <Route exact path={'/categories'} component={Categories} />
        <Route exact path={'/category/:id'} component={CategoryDetail} />
        <Route exact path={'/top-chart'} component={TopChart} />
        <Route path={'/forgot-password'} component={ForgotPassword} />
        <Route path={'/change-password'} component={ChangePassword} />
        <Route path={'/edit-profile'} component={EditProfile} />
        <Route path={'/products'} component={ProductSearch} />
      </Switch>
    </Router>
  )
}
